<template>
  <span>
    <template>
      <vs-button
          color="danger"
          v-bind:class="[`float-${float}`]"
          @click="penalizeModal()">
          Penalizar
      </vs-button>

      <vs-popup title="Penalizar" :active.sync="showCommissionDialog">
        <vs-input
            class="w-full"
            type="number"
            label="Factura"
            disabled
            :value="project.totalCost"
            icon="attach_money"></vs-input>

        <vs-input
            class="w-full mt-2"
            label="Fecha límite de pago a proveedor"
            disabled
            :value="limitDateForPay"
            icon="event"></vs-input>

        <vs-input
            class="w-full mt-2"
            label="Semanas retrasadas"
            disabled
            :value="weekLatest"
            icon="event"></vs-input>

        <vs-input
            type="number"
            class="w-full mt-2"
            label="Monto disponible para penalizar"
            disabled
            :value="amount_available"
            icon="attach_money"></vs-input>

        <vs-input
            type="number"
            class="w-full mt-2"
            label="Monto de la mensualidad"
            disabled
            :value="project.monthlyPayment"
            icon="attach_money"></vs-input>

        <vs-input
            type="number"
            class="w-full mt-2"
            label="Penalización calculada"
            disabled
            :value="amountForPenalizeSuggested"
            icon="attach_money"></vs-input>

        <vs-input
            type="number"
            class="w-full mt-2"
            label="Monto a penalizar"
            v-model="penalize_amount"
            icon="attach_money"></vs-input>

        <div class="mt-6">
          <vs-button
              color="dark"
              @click="showCommissionDialog = false">Cancelar</vs-button>

          <vs-button
              class="ml-4"
              color="success"
              @click="penalize()"
              :disabled="penalize_amount === 0">Penalizar</vs-button>
          </div>
      </vs-popup>
    </template>
  </span>
</template>

<script>
import {AxiosErrorException} from "@views/admin/functions/axiosErrorException";
import * as moment from 'moment'

export default {
  name: "PenalizeButton",
  data() {
    return {
      parameters: [],
      payments: [],
      amount_available: 0,
      supplier_penalty_per_week_percentage: 0,
      supplier_installation_sla: 0,
      showCommissionDialog: false,
      perc: 1,
      penalize_amount: 0,
      email_note: ""
    }
  },
  computed: {
    limitDateForPay() {
      return moment(this.project.installationDate)
          .add(this.supplier_installation_sla, 'days')
          .format('Y-MM-DD')
    },
    weekLatest() {
      let today = moment();

      let installationDate = moment(this.project.installationDate);
      let subDays = installationDate.diff(today, 'days', true);
      subDays += parseInt(this.supplier_installation_sla);
      return (subDays / 7).toFixed(0);
    },
    amountForPenalizeSuggested() {
      return (this.project.totalCost * (parseInt(this.supplier_penalty_per_week_percentage) / 100)) * this.weekLatest
    },

  },
  props: ['float', 'project'],
  async beforeMount() {
    this.parameters = await axios.get('/api/v1/default-parameters?filter[field_name][]=supplier_installation_sla&filter[field_name][]=supplier_penalty_per_week_percentage')
    this.payments = await axios.get(`/api/v1/supplier-payments?filter[trx_type]=S111&filter[project_id]=${this.project.id}`)
    this.amount_available = this.getAmountAvailable();
    this.supplier_penalty_per_week_percentage = this.getSupplierPenaltyPerWeekPercentage()[0].value;
    this.supplier_installation_sla = this.getSupplierInstallationSla()[0].value;
  },
  methods: {
    async penalizeModal() {
      this.showCommissionDialog = true;
    },
    getAmountAvailable() {
      let totalAmount = 0;
      this.payments.data.data.forEach(function (item) {
        if (item.status === 0) {
          totalAmount += parseFloat(item.amount);
        }
      });

      return totalAmount;
    },
    getSupplierPenaltyPerWeekPercentage() {
      return this.parameters.data.data.filter(function (item) {
        return item.field_name === 'supplier_penalty_per_week_percentage';
      });
    },
    getSupplierInstallationSla() {
      return this.parameters.data.data.filter(function (item) {
        return item.field_name === 'supplier_installation_sla';
      });
    },
    async penalize() {
      try {
        await axios.post(`/api/project/${this.project.id}/penalize`, {
          penalize_amount: this.penalize_amount
        });

        this.showCommissionDialog = false;
        swal("Ok!", "Se registro la penalización correctamente", "success")
      } catch (e) {
        console.error(e)
        swal('Ups!', AxiosErrorException(e), "error");
      }
    }
  }
}
</script>

<style scoped>

</style>
